module.exports = "/images/asensores.svg?26a9cb4d7b023d70f7d19d4f8cba8d60";